import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { customThemeWithHeaders } from "@/pages/adjustments/manager/components/table/AdjustmentsManagerTable";
import { GridApi } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { RejectedBillet } from "../models/RejectedBillet";
import { EditBilletCountModal } from "./EditBilletCountModal";
import { useTableData } from "./hooks/useTableData";

interface Props {
	rows: RejectedBillet[];
	isLoading: boolean;
	shiftId: number | undefined;
	onGridReady: (api: GridApi<RejectedBillet>) => void;
}

export const RejectedManagerTable = ({
	rows,
	isLoading,
	shiftId,
	onGridReady,
}: Props) => {
	const [editingRow, setEditingRow] = useState<RejectedBillet | null>(null);

	const { columnDefs } = useTableData({
		onEditClick: (row) => setEditingRow(row),
	});
	const { defaultColDef } = useGridDefinitions({});

	return (
		<>
			<AgGridReact<RejectedBillet>
				loading={isLoading}
				rowData={rows}
				columnDefs={columnDefs}
				defaultColDef={defaultColDef}
				rowHeight={34}
				headerHeight={34}
				animateRows
				suppressContextMenu
				loadingOverlayComponent={CenteredLazyLoading}
				rowSelection="single"
				onGridReady={(params) => onGridReady(params.api)}
				getRowId={(params) => String(params.data.RejectedBilletId)}
				gridOptions={{
					rowSelection: {
						mode: "singleRow",
						checkboxes: false,
						enableClickSelection: true,
					},
					theme: customThemeWithHeaders,
				}}
			/>
			<EditBilletCountModal
				row={editingRow}
				shiftId={shiftId}
				onHide={() => setEditingRow(null)}
			/>
		</>
	);
};
